import React from "react";
import { X, CheckCircle2, AlertTriangle, XCircle } from "lucide-react";
import { formatNumber } from "../../../lib/utils";

// Validation report for CSV imports (supersession links and install base).
export default function ImportReport({ report, kind, onClose }) {
  const rejected = report.rejected || [];
  const warnings = report.warnings || [];
  return (
    <div data-testid={`${kind}-report`} className="border border-border bg-surface-2/40 rounded-sm p-3 text-[11.5px] space-y-2 animate-fade-in">
      <div className="flex items-center gap-4 flex-wrap">
        <span className="font-semibold uppercase tracking-widest text-[10px] text-muted">Validation report</span>
        <span className="font-mono-tabular" data-testid={`${kind}-report-total`}>{formatNumber(report.rows_total)} rows</span>
        <span className="text-success inline-flex items-center gap-1 font-mono-tabular" data-testid={`${kind}-report-accepted`}><CheckCircle2 size={11} /> {formatNumber(report.accepted)} valid</span>
        <span className="text-critical inline-flex items-center gap-1 font-mono-tabular" data-testid={`${kind}-report-rejected`}><XCircle size={11} /> {rejected.length} rejected</span>
        {warnings.length > 0 && <span className="text-warning inline-flex items-center gap-1 font-mono-tabular"><AlertTriangle size={11} /> {warnings.length} warnings</span>}
        {report.applied !== undefined && <span className={report.applied ? "text-success" : "text-muted"} data-testid={`${kind}-report-applied`}>{report.applied ? "Applied · pipeline re-ran" : "Nothing applied"}</span>}
        {onClose && <button data-testid={`${kind}-report-close`} onClick={onClose} className="ml-auto w-6 h-6 inline-flex items-center justify-center hover:bg-surface-2 rounded-sm"><X size={12} /></button>}
      </div>
      {(rejected.length > 0 || warnings.length > 0) && (
        <ul className="max-h-[160px] overflow-y-auto space-y-0.5 font-mono-tabular text-[10.5px]">
          {rejected.map((r, i) => <li key={`r${i}`} className="text-critical">Line {r.line}: {r.errors.join(" ")}</li>)}
          {warnings.map((w, i) => <li key={`w${i}`} className="text-warning">Line {w.line}: {w.warning}</li>)}
        </ul>
      )}
    </div>
  );
}
